import styled from 'styled-components';
import { Body } from 'syf-component-library/ui/typography';
export const Paragraph = styled(Body) `
  margin-top: ${({ theme }) => theme.spacing.large}px;
  text-align: center;
`;
//# sourceMappingURL=typography.js.map